import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const BreadcrumbContainer = styled.nav`
  padding: 20px 200px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  
  @media (max-width: 1200px) {
    padding: 20px 100px;
  }
  
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const BreadcrumbList = styled.ol`
  list-style: none;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
`;

const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:not(:last-child)::after {
    content: '›';
    color: rgba(255, 255, 255, 0.4);
  }
`;

const BreadcrumbLink = styled(Link)`
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s;
  
  &:hover {
    color: #1F53FF;
  }
`;

const BreadcrumbCurrent = styled.span`
  color: white;
`;

interface BreadcrumbItemType {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItemType[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <BreadcrumbContainer aria-label="Breadcrumb">
      <BreadcrumbList>
        {items.map((item, index) => (
          <BreadcrumbItem key={index}>
            {item.path ? (
              <BreadcrumbLink to={item.path}>{item.label}</BreadcrumbLink>
            ) : (
              <BreadcrumbCurrent>{item.label}</BreadcrumbCurrent>
            )}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </BreadcrumbContainer>
  );
};
